import React from "react";
import clsx from "clsx";

const LandingOrbs = ({ scale, blur, zIndex }: { scale: number; blur: number; zIndex: number }) => {
  return (
    <div className={clsx("absolute inset-0 z-0 pointer-events-none w-screen h-screen  ")}>
      <div
        className="w-screen h-screen max-w-screen-lg mx-auto transform-gpu origin-center transition-transform duration-500"
        style={{
          transform: `scale(${scale})`,
          filter: `blur(${blur}px)`,
          zIndex: zIndex,
        }}
      >
        <div className="relative w-full h-full mx-auto md:w-96">
          <div className="orb z-30 absolute top-20 right-10 md:top-16 md:right-28 w-28 md:w-64" />
          <div className="orb z-10 absolute top-32 right-4 md:top-52 md:right-7 w-20 md:w-44" />
          <div className="orb z-20 absolute top-24 right-2 md:top-28 md:right-5 w-14 md:w-32" />
        </div>
      </div>
    </div>
  );
};

export default LandingOrbs;
